import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'
import { Feedback } from 'screens/feedback'

const FeedbackPage: NextPageFC<Empty, PageLayoutOwnProps> = () => Feedback()

FeedbackPage.layout = PageLayout

FeedbackPage.headProps = {
	title: pagesTitles[PagesPath.about].title,
	description:
		'Узнайте больше об инвестиционной платформе Credit.Club: свидетельства и уставные документы, отзывы клиентов. Работаем под надзором Банка России.',
	ogTitle: pagesTitles[PagesPath.about].title,
	ogDescription:
		'Узнайте больше об инвестиционной платформе Credit.Club: свидетельства и уставные документы, отзывы клиентов. Работаем под надзором Банка России.',
}

export default FeedbackPage
